<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Set price' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <form novalidate [formGroup]="setPriceForm">
          <div class="input-group text-center">
            <div class="input-group-prepend no-caret" ngbDropdown>
              <button
                class="btn btn-outline-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                ngbDropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-minus': setPriceForm.controls.negative.value,
                    'fa-plus': !setPriceForm.controls.negative.value
                  }"
                ></i>
              </button>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a
                  class="dropdown-item"
                  href="#"
                  (click)="
                    setPriceForm.controls.negative.setValue(true); (false)
                  "
                  >{{ 'Minus' | translate }}</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  (click)="
                    setPriceForm.controls.negative.setValue(false); (false)
                  "
                  >{{ 'Plus' | translate }}</a
                >
              </div>
            </div>

            <input
              type="text"
              class="form-control text-center"
              aria-label=""
              formControlName="amount"
              autocomplete="chrome-off"
              [class.is-invalid]="sent && setPriceForm.get('amount').errors"
            />

            <!-- Validation errors -->
            <span
              class="invalid-feedback order-last"
              *ngIf="sent && setPriceForm.get('amount').hasError('required')"
              >{{ 'global.validators.required.error' | translate }}</span
            >
            <span
              class="invalid-feedback order-last"
              *ngIf="
                sent && setPriceForm.get('amount').hasError('invalidNumber')
              "
              >{{ 'Invalid number' | translate }}</span
            >

            <div
              class="input-group-append no-caret"
              ngbDropdown
              container="body"
              placement="bottom-right"
            >
              <button
                class="btn btn-outline-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                ngbDropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-percent': setPriceForm.controls.percent.value,
                    'fa-dollar-sign': !setPriceForm.controls.percent.value
                  }"
                ></i>
              </button>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a
                  class="dropdown-item"
                  href="#"
                  (click)="
                    setPriceForm.controls.percent.setValue(true); (false)
                  "
                  >{{ 'Percent' | translate }}</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  (click)="
                    setPriceForm.controls.percent.setValue(false); (false)
                  "
                  >{{ 'Amount' | translate }}</a
                >
              </div>
            </div>
          </div>
        </form>

        <p class="text-muted mt-3">{{ 'set-price.description' | translate }}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span>{{ 'global.save' | translate }}</span>
    </button>
  </div>
</div>
